export const selectsDictionary = {
  accounts: "accounts",
  units: "units",
};
